export const getLikedAudioIdsUrl = () => `audio/like/all`

export const likeAudioUrl = () => `audio/like/create`

export const unlikeAudioUrl = () => `audio/like/delete`
